<template>
  <div class="tm-zoom flex">
    <div class="center zoom" @click="center()">
      <img
        class="tm-svg-icon tm-svg-fill"
        src="../../public/icons/mm/ic_map_origin.png"
      />
    </div>
    <div class="center zoom" style="padding-top: 0" @click="self()">
      <img
        class="tm-svg-icon tm-svg-fill"
        src="../../public/icons/mm/ic_map_screen.png"
      />
    </div>
    <div class="max" @click="enmax()">
      <img
        class="tm-svg-icon tm-svg-fill"
        src="../../public/icons/mm/ic_map_enlarge.png"
      />
    </div>
    <div class="tm-slider">
      <div class="tm-slider-bg" ref="slider">
        <div class="tm-slider-progress" :style="{ height }"></div>
        <div class="tm-slider-button-area" ref="trunk" :style="{ bottom }">
          <div class="tm-slider-button"></div>
        </div>
      </div>
    </div>
    <div class="min" @click="enmin()">
      <img
        class="tm-svg-icon tm-svg-fill"
        src="../../public/icons/mm/ic_map_shrink.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["min", "max", "init_per", "sizeMethod"],
  data() {
    return {
      slider: null, //滚动条DOM元素
      thunk: null, //拖拽DOM元素
      per: 0,
    };
  },
  watch: {
    init_per(newVal, oldVal) {
      this.per = newVal;
    },
    sizeMethod(newVal, oldVal) {
      if (newVal && newVal.method) {
        this[newVal.method]();
      }
    },
  },
  //渲染到页面的时候
  mounted() {
    this.slider = this.$refs.slider;
    this.thunk = this.$refs.trunk;
    // 点击滑块
    this.thunk.onmousedown = (e) => {
      console.log("点击滑块", e);
      var height = parseInt(this.height);
      var origin_Y = e.clientY;

      document.onmousemove = (e) => {
        // console.log('拖动滑块',e)

        // var newHeight =  e.clientY - origin_Y + height;
        var newHeight = origin_Y - e.clientY + height;
        // 拖拽的时候得到新的百分比
        var scale = newHeight / this.slider.offsetHeight;
        // console.log({scale})
        this.per = Math.ceil((this.max - this.min) * scale + this.min);
        // 防止滑动过高或过低
        this.per = Math.max(this.per, this.min);
        this.per = Math.min(this.per, this.max);

        this.$emit("scale_move", this.per);
      };
      document.onmouseup = function () {
        // 松开滑块
        document.onmousemove = document.onmouseup = null;
      };
      return false;
    };
  },
  computed: {
    // 设置一个百分比，提供计算slider进度宽度和trunk的left值
    // 对应公式为  当前值-最小值/最大值-最小值 = slider进度width / slider总width
    // trunk left =  slider进度width + trunk宽度/2
    scale() {
      return (this.per - this.min) / (this.max - this.min);
    },
    // 整个silder的高度
    height() {
      if (this.slider) {
        // console.log('hegiht',this.slider.offsetHeight)
        return this.slider.offsetHeight * this.scale + "px";
      } else {
        return 0 + "px";
      }
    },
    // 滑动的距离
    bottom() {
      if (this.slider) {
        return this.slider.offsetHeight * this.scale - this.thunk.offsetHeight / 2 + "px";
      } else {
        return 0 + "px";
      }
    },
  },
  methods: {
    enmax() {
      this.per = this.per + 1;
      this.per = Math.max(this.per, this.min);
      this.per = Math.min(this.per, this.max);
      this.$emit("scale_move", this.per);
    },
    enmin() {
      this.per = this.per - 1;
      this.per = Math.max(this.per, this.min);
      this.per = Math.min(this.per, this.max);
      this.$emit("scale_move", this.per);
    },
    center() {
      this.$emit("makeCenter");
    },
    self() {
      this.$emit("fitContent");
    },
  },
};
</script>

<style lang="scss">
.tm-zoom {
  font-size: 18px;
  z-index: 500;
  width: 28px;
  color: #8a8a8a;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #ebebeb;
  margin: 0 auto;

  &.flex {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .tm-svg-icon {
    display: inline-block;
    overflow: hidden;
    width: 1em;
    max-width: 100%;
    height: 1em;
    max-height: 100%;
    cursor: pointer;
    vertical-align: -0.15em;
    color: inherit;
    outline: none;
    fill: currentColor;
    stroke: currentColor;
  }

  .tm-svg-fill {
    fill: currentColor;
    stroke: none;
  }

  .max {
    padding-bottom: 6px;
  }

  .min {
    padding-top: 6px;
  }

  .center {
    padding: 0;
  }

  .tm-slider {
    height: 80px;
    position: relative;
    width: 10px;

    .tm-slider-bg {
      height: 100%;
      background: #bbbbbb;
      width: 4px;
      border-radius: 2px;
      margin: 0 auto;

      .tm-slider-progress {
        bottom: 0%;
        height: 50.57143%;
        background: #409eff;
        width: 4px;
        position: absolute;
        border-radius: 2px;
      }

      .tm-slider-button-area {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 16px;

        .tm-slider-button {
          width: 16px;
          height: 16px;
          border: 2px solid #409eff;
          background-color: #fff;
          border-radius: 50%;
          -webkit-transition: 0.2s;
          transition: 0.2s;
          user-select: none;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
